import * as Sentry from '@sentry/react';
import {
  API_BASE_URL,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
} from '@/common/config/runtime.ts';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: SENTRY_RELEASE,
  tunnel: `${API_BASE_URL}/api/v1/sentry-tunnel`,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [API_BASE_URL],
  beforeSend(event) {
    if (event.request?.headers) {
      delete event.request.headers.Authorization;
      delete event.request.headers.authorization;
      delete event.request.headers.Cookie;
      delete event.request.headers.cookie;
    }
    if (event.user) {
      delete event.user.ip_address;
    }
    return event;
  },
});
